export const DISCOVER_STRINGS = {
  en: {
    TITLE: 'Studios in',
    DESCRIPTION: [
      'Bruce Studios gives you access to hundreds of studios in',
      'and other cities. This page lists studios related to',
    ],
    EXPLORE_ALL_STUDIOS: 'Explore all studios',
    OTHER_VICINITIES: 'Other vicinities in',
    OTHER_CATEGORIES: 'Other categories in',
    NO_STUDIOS_FOUND: 'No studios found',
  },
  sv: {
    TITLE: 'Studios i',
    DESCRIPTION: [
      'Med Bruce Studios kan du träna på hundratals studios i',
      'och andra städer. Här hittar du våra studios i kategorin',
    ],
    EXPLORE_ALL_STUDIOS: 'Kolla in alla våra studios',
    OTHER_VICINITIES: 'Andra områden i',
    OTHER_CATEGORIES: 'Andra kategorier i',
    NO_STUDIOS_FOUND: 'Inga studios hittade',
  },
  nb: {
    TITLE: 'Studios i',
    DESCRIPTION: [
      'Med Bruce Studios kan du trene på hundrevis av studios i',
      'og andre byer. Her finner du studios i kategorien',
    ],
    EXPLORE_ALL_STUDIOS: 'Utforsk alle studios',
    OTHER_VICINITIES: 'Andre områder i',
    OTHER_CATEGORIES: 'Andre kategorier i',
    NO_STUDIOS_FOUND: 'Ingen studios funnet',
  },
  da: {
    TITLE: 'Studios i',
    DESCRIPTION: [
      'Med Bruce Studios kan du træne i hundredvis af studios i',
      'og andre byer. Her finder du vores studios i kategorien',
    ],
    EXPLORE_ALL_STUDIOS: 'Se alle vores studios',
    OTHER_VICINITIES: 'Andre områder i',
    OTHER_CATEGORIES: 'Andre kategorier i',
    NO_STUDIOS_FOUND: 'Ingen studios fundet',
  },
}
